import { FullBleed, Padding } from './styles';

const Page = {
    FullBleed,
    Padding,
};

export { Page };
